import { render, staticRenderFns } from "./AddMusic.vue?vue&type=template&id=03e0472c&scoped=true&"
import script from "./AddMusic.vue?vue&type=script&lang=js&"
export * from "./AddMusic.vue?vue&type=script&lang=js&"
import style0 from "./AddMusic.vue?vue&type=style&index=0&id=03e0472c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e0472c",
  null
  
)

export default component.exports